import React, { Component } from 'react'
import { getValueCookie } from '../../services/cookieService';
import { getInformationWithDataV3 } from '../../services/CABE';
import '../../css/dashboard.css'
import LoadingWindow from '../../components/LoadingWindow';
import { AiOutlineSearch, AiOutlineHistory } from "react-icons/ai";
import { Menu } from "../../components/Menu/Menu";

/**
 * TraceabilityV3 — new report (2026-08-18), not a clone of any v2 page.
 *
 * Client complaint: no traceability on who edited a Sales Order or who
 * converted it to an Invoice — sales_orders_aws_v2.username/.salesperson_no
 * are single mutable columns, overwritten on every save, so the original
 * salesperson disappears once a manager edits the SO or someone else
 * generates the Invoice. This page shows the append-only timeline from
 * document_audit_trail (see api-portal-manager's documentAuditTrail.ts /
 * migration 014) for one Sales Order — its own actions plus any Invoice
 * action linked back to it.
 *
 * Only Sales-Order-side events exist today (SalesOrderV3.js writes
 * 'created'). Invoice-side events ('converted_to_invoice') will appear here
 * automatically once Invoices V3 exists and calls the same /v3/audit/log
 * endpoint — another programmer is building that page, this report doesn't
 * need to change when it lands.
 */
export default class TraceabilityV3 extends Component {
    constructor(props) {
        super(props)
        this.ModalLoading = React.createRef();
    }

    state = {
        docNo: '',
        idCompany: getValueCookie('CompanyId') || '',
        trail: [],
        searched: false,
        loadError: '',
    }

    onChangeDocNo = (e) => {
        this.setState({ docNo: e.target.value.toUpperCase() })
    }

    onKeyDown = (e) => {
        if (e.key === 'Enter') this.search()
    }

    async search() {
        const docNo = this.state.docNo.trim()
        if (!docNo) return
        this.ModalLoading.current.showState(true)
        this.setState({ loadError: '' })
        try {
            const resp = await getInformationWithDataV3('/v3/audit/trail', {
                docNo,
                idCompany: Number(this.state.idCompany),
            })
            if (resp && resp.status && resp.status.code === 1) {
                this.setState({ trail: resp.data || [], searched: true })
            } else {
                this.setState({ trail: [], searched: true, loadError: 'Could not load the traceability data for this document.' })
            }
        } catch (error) {
            console.error('TraceabilityV3 search failed:', error)
            this.setState({ trail: [], searched: true, loadError: 'Could not load the traceability data — the server did not respond.' })
        } finally {
            this.ModalLoading.current.showState(false)
        }
    }

    actionBadge(action) {
        const styles = {
            created: { bg: 'rgba(37,99,235,0.08)', color: '#1e40af', label: 'Created' },
            edited: { bg: 'rgba(245,158,11,0.08)', color: '#92400E', label: 'Edited' },
            converted_to_invoice: { bg: 'rgba(16,185,129,0.08)', color: '#065F46', label: 'Converted to Invoice' },
        }
        const s = styles[action] || { bg: 'rgba(100,116,139,0.08)', color: '#334155', label: action }
        return (
            <span style={{
                background: s.bg, color: s.color, border: `1px solid ${s.color}33`,
                borderRadius: '999px', padding: '3px 12px', fontSize: '0.78rem', fontWeight: 700,
            }}>{s.label}</span>
        )
    }

    docTypeLabel(docType) {
        return docType === 'invoice' ? 'Invoice' : 'Sales Order'
    }

    render() {
        const { trail, searched } = this.state

        return (
            <div className="dash-page pb-5">
                <Menu Refresh={this.state.Refresh} Father={this} />
                <LoadingWindow ref={this.ModalLoading} />

                <div style={{ marginTop: 30, background: 'linear-gradient(135deg, #0f172a 0%, #1e3a5f 50%, #2563EB 100%)', padding: '2rem 2rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '1rem', flexWrap: 'wrap' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                        <div style={{ background: 'rgba(255,255,255,0.12)', borderRadius: '12px', padding: '0.75rem', display: 'flex' }}>
                            <AiOutlineHistory style={{ color: 'white', fontSize: '1.75rem' }} />
                        </div>
                        <div>
                            <h1 style={{ color: 'white', fontWeight: 800, fontSize: '1.375rem', margin: 0 }}>Traceability (V3)</h1>
                            <p style={{ color: 'rgba(255,255,255,0.6)', margin: 0, fontSize: '0.8rem' }}>Full history of a Sales Order, from creation to invoice</p>
                        </div>
                    </div>

                    <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
                        <input
                            type="text"
                            autoComplete="off"
                            placeholder="Sales Order No. (e.g. AL64684)"
                            value={this.state.docNo}
                            onChange={this.onChangeDocNo}
                            onKeyDown={this.onKeyDown}
                            style={{ padding: '0.65rem 1rem', border: 'none', borderRadius: '10px', fontSize: '0.9375rem', width: '260px', outline: 'none' }}
                        />
                        <button
                            onClick={() => this.search()}
                            type="button"
                            style={{
                                background: 'rgba(255,255,255,0.15)', border: '1px solid rgba(255,255,255,0.25)',
                                borderRadius: '10px', color: 'white', padding: '0.65rem 1.25rem', fontWeight: 600,
                                fontSize: '0.9375rem', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '0.5rem',
                            }}
                        >
                            <AiOutlineSearch /> Search
                        </button>
                    </div>
                </div>

                <div className="container-fluid" style={{ marginTop: 24 }}>
                    {this.state.loadError && (
                        <div className="metric-card status-danger mb-3">
                            <div style={{ color: '#DC2626', fontSize: '0.85rem' }}>{this.state.loadError}</div>
                        </div>
                    )}

                    {searched && trail.length === 0 && !this.state.loadError && (
                        <div style={{ textAlign: 'center', padding: '4rem 2rem', color: '#94A3B8' }}>
                            <AiOutlineHistory style={{ fontSize: '3rem', marginBottom: '1rem', opacity: 0.4 }} />
                            <p style={{ margin: 0, fontSize: '1rem' }}>No traceability history found for <strong>{this.state.docNo}</strong>.</p>
                            <p style={{ margin: 0, fontSize: '0.85rem' }}>This document may have been saved before traceability tracking started (2026-08-18).</p>
                        </div>
                    )}

                    {!searched && (
                        <div style={{ textAlign: 'center', padding: '4rem 2rem', color: '#94A3B8' }}>
                            <AiOutlineSearch style={{ fontSize: '3rem', marginBottom: '1rem', opacity: 0.4 }} />
                            <p style={{ margin: 0, fontSize: '1rem' }}>Enter a Sales Order number above to see its full history.</p>
                        </div>
                    )}

                    {trail.length > 0 && (
                        <div className="card" style={{ border: '1px solid #E2E8F0', borderRadius: '16px', padding: '1.5rem 2rem' }}>
                            {trail.map((row, i) => (
                                <div key={row.id || i} style={{
                                    display: 'flex', gap: '1rem', alignItems: 'flex-start',
                                    padding: '1rem 0', borderTop: i === 0 ? 'none' : '1px solid #F1F5F9',
                                }}>
                                    <div style={{
                                        width: '10px', height: '10px', borderRadius: '50%',
                                        background: '#2563EB', marginTop: '6px', flexShrink: 0,
                                    }} />
                                    <div style={{ flex: 1 }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', flexWrap: 'wrap' }}>
                                            {this.actionBadge(row.action)}
                                            <span style={{ fontWeight: 700, color: '#0F172A' }}>{this.docTypeLabel(row.docType)} {row.docNo}</span>
                                            {row.linkedSoNo && row.docType === 'invoice' && (
                                                <span style={{ fontSize: '0.78rem', color: '#64748B' }}>from Sales Order {row.linkedSoNo}</span>
                                            )}
                                        </div>
                                        <div style={{ marginTop: '4px', fontSize: '0.85rem', color: '#334155' }}>
                                            By <strong>{row.performedBy}</strong>
                                            {row.salespersonNo && <> · Salesperson <strong>{row.salespersonNo}</strong></>}
                                        </div>
                                        <div style={{ marginTop: '2px', fontSize: '0.78rem', color: '#94A3B8' }}>
                                            {row.performedAt ? new Date(row.performedAt).toLocaleString() : ''}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        );
    }
}
